/**
 * Whether the schedule selection panel should ignore Dialog onClose
 * (backdrop / Escape) while time-picker or series scope/conflict UI is open.
 */
export function shouldBlockScheduleSelectionDialogClose(
  blockCloseForTimeEdit: boolean,
  reason: "backdropClick" | "escapeKeyDown"
): boolean {
  return blockCloseForTimeEdit && (reason === "backdropClick" || reason === "escapeKeyDown");
}
